import { useSelector } from 'react-redux';
import { canAddModule, canMoveModule, canViewPage } from '../redux/selectors/privileges';
import useGruser from './useGruser';
export const usePrivileges = ()=>{
    const { gruser } = useGruser();
    return {
        canAddModule: !!useSelector((state)=>canAddModule(state, gruser)),
        canMoveModule: !!useSelector((state)=>canMoveModule(state, gruser)),
        canViewPage: !!useSelector((state)=>canViewPage(state, gruser))
    };
};
export default usePrivileges;
